/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".type-charts[_ngcontent-%COMP%]{display:flex;flex-flow:column nowrap;justify-content:flex-start;margin-top:10px}.type-charts[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin-bottom:20px}.satisfacao[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:space-between}.item-satisfacao[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:center;gap:5px}"];
export { styles as styles };
